import { IConfig } from '../types/IConfig';
import { createContext } from 'react';

export const defaultConfigContext = {
  settings: null
}

export const ConfigContext = createContext<IConfig>(defaultConfigContext);

